import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { GraduationCap, Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/slp/forgot-password`, { email });
      setSent(true);
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'var(--fe-bg)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-[#2C4C3B] rounded-2xl mb-4">
            <GraduationCap className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-4xl font-semibold text-[#1C1C1C] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>FrameEd</h1>
          <p className="text-[#595959]">Referrals</p>
        </div>

        <div className="bg-white rounded-2xl border border-[#E5E5E5] p-8">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-12 h-12 rounded-2xl bg-[#2C4C3B]/10 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-6 h-6 text-[#2C4C3B]" />
              </div>
              <h2 className="text-xl font-semibold text-[#1C1C1C] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Check Your Email</h2>
              <p className="text-sm text-[#595959] mb-6">If an account exists with <strong>{email}</strong>, we've sent a password reset link. It expires in 1 hour.</p>
              <Link to="/slp/login" className="inline-flex items-center gap-2 text-[#2C4C3B] font-medium hover:underline text-sm">
                <ArrowLeft className="w-4 h-4" />Back to Login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-xl font-semibold text-[#1C1C1C] mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Reset Password</h2>
              <p className="text-sm text-[#595959] mb-6">Enter your email and we'll send you a link to reset your password.</p>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-[#1C1C1C] mb-1.5">
                    <Mail className="w-4 h-4 inline mr-2 text-[#595959]" />Email Address
                  </label>
                  <input
                    type="email"
                    required
                    data-testid="forgot-password-email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your.email@school.edu"
                    className="w-full h-11 px-4 rounded-xl border border-[#E5E5E5] bg-[#FAFAF8] text-sm focus:ring-2 focus:ring-[#2C4C3B]/30 focus:border-[#2C4C3B] outline-none transition-all"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="forgot-password-submit"
                  className="w-full bg-[#2C4C3B] hover:bg-[#1E3629] text-white font-medium rounded-xl px-6 py-3 transition-colors disabled:bg-[#E5E5E5] disabled:text-[#595959] disabled:cursor-default"
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <div className="mt-6 pt-6 border-t border-[#E5E5E5] text-center">
                <Link to="/slp/login" className="inline-flex items-center gap-2 text-sm text-[#595959] hover:text-[#2C4C3B] transition-colors">
                  <ArrowLeft className="w-4 h-4" />Back to Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
